import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.scss'],
    standalone: false
})
export class PanelComponent implements OnInit {
//  @Input() styleStr = {}; // добавить стиль в виде массива
  @Input() // добавить стиль в виде массива
  public set styleStr(value: object) {
// 
    this._styleStr = value;
  };

/*

  get styleStr(): Object{
    return this._styleStr;
  };
*/


  @Input() public classSrt = ''; // добавочный класс

  public _styleStr: Object = {};

  public constructor() { }

  public ngOnInit(): void {
//    this._styleStr = this.styleStr;
  }

}
